// Deterministic pseudo-random numbers, so the same island always looks the same.

/** Returns a generator of numbers in [0, 1) seeded by a cell and an optional salt (mulberry32 variant). */
export function seeded(a: number, b: number, salt = 0): () => number {
  let t = (a * 7919 + b * 104729 + salt * 31337) >>> 0;
  return () => {
    t = (t + 0x6d2b79f5) >>> 0;
    let r = Math.imul(t ^ (t >>> 15), 1 | t);
    r ^= r + Math.imul(r ^ (r >>> 7), 61 | r);
    return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
  };
}
